import React from 'react';
import { FaBullhorn, FaEye, FaUsers } from 'react-icons/fa';
import './MissionVisionValues.css';

const MissionVisionValues = () => {
  const sections = [
    {
      id: 1,
      icon: <FaBullhorn />,
      title: 'Our Mission',
      description:
        ' To deliver impactful, creative content through professional video production services that resonate with audiences and support the full video and production process.',
    },
    {
      id: 2,
      icon: <FaEye />,
      title: 'Our Vision',
      description:
        'To be a global leader among video production companies by driving innovation, creativity, and collaboration, creating memorable experiences through top-tier video production worldwide.',
    },
    {
      id: 3,
      icon: <FaUsers />,
      title: 'Our Values',
      description:
        'As a video production firm, we believe in integrity, teamwork, and excellence. We value lasting partnerships with clients, directing companies, and our team, striving for success through shared respect.',
    },
  ];

  return (
    <section className="mission-vision-values-section">
      <div className="mission-vision-values-container">
        <h2 className="mission-vision-values-title">Our Mission, Vision & Values</h2>
        <div className="mission-vision-values-items">
          {sections.map((section) => (
            <div className="mission-vision-values-item" key={section.id}>
              <div className="icon-container">{section.icon}</div>
              <div className="text-content">
                <h3 className="section-title">{section.title}</h3>
                <p className="section-description">{section.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionVisionValues;
